import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=23d48dea&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=23d48dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d48dea",
  null
  
)

export default component.exports